import React, { useState } from 'react'
import styled from 'styled-components'
import getThumbnailFromUrl from '../../../utils/getThumbnailOfVideo'
import { Movie as MovieType } from '../types'

const S = {
    Wrapper: styled.div`
        position: relative;
        display: flex;
        cursor: pointer;
        &:hover div {
            color: #ffb52b;
        }
        &:hover .cinema-play-indicator {
            opacity: 1;
        }
        &:hover img {
            filter: brightness(80%);
        }
    `,
    Image: styled.img`
        width: 120px;
        height: 80px;
        object-fit: cover;
        object-position: center;
        border-radius: 4px;
        transition: 0.2s;
        @media (max-width: 1366px) {
            width: 100px;
        }
    `,
    PlayIndicator: styled.div`
        position: absolute;
        top: 30px;
        left: 57px;
        width: 0; 
        height: 0; 
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent; 
        border-left:18px solid white; 
        opacity: 0;
        transition: 0.2s;
        @media (max-width: 1366px) {
            left: 41px;
        }
    `,
    Description: styled.div`
        width: 190px;
        margin-left: 10px;
        color: white;
        transition: 0.2s;
        @media (max-width: 1366px) {
            width: 140px;
        }
    `,
    Title: styled.h5`
        max-height: 30px;
        margin-bottom: 5px;
        font-size: 12px;
        font-weight: 500;
        line-height: 15px;
    `,
    SubTitle: styled.p`
        max-height: 47px;
        margin: 0;
        font-size: 10px;
        font-weight: 400;
        line-height: 12px;
    `
}

const MovieThumbnail = (
    { item, onClick }: {item: MovieType, onClick:() => void}
) => {
    const [thumbnail, setThumbnail] = useState(item.image_thumbnail_url) // Priority use thumbnail by admin setting
    if (!thumbnail) { // If not, will get thumbnail from api
        getThumbnailFromUrl(item.embedded_url).then((data) => setThumbnail(data))
    }

    return (
        <S.Wrapper onClick={onClick}>
            <S.Image src={thumbnail} />
            <S.PlayIndicator className="cinema-play-indicator" />
            <S.Description>
                <S.Title className="text-cut-line-2">{item.title}</S.Title>
                <S.SubTitle className="text-cut-line-4">{item.subtitle}</S.SubTitle>
            </S.Description>
        </S.Wrapper>
    )
}

export default MovieThumbnail
